import { type IAudioContextState } from './types'

export const AudioContextInitialState: IAudioContextState = {
    mediaUrl: '',
    listened: 0,
    audioReady: true,
    fullyListened: false,
    playing: false,
    currentTime: 0,
    duration: 0
}
